import ENV from "config/Env";
import { typedQueryClient, useTypedMutation, userKey } from "hooks";
import { refetchAppointments } from "modules/Appointments/hooks";
import { ApiInstance } from "utils/Api";

import type { User } from "models";

export const useUpdateUserAccountMutation = () =>
  useTypedMutation<User, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/users/account/update", payload, ENV.systemBaseURL);
    },
    onSuccess: payload => {
      const user = typedQueryClient.getQueryData(userKey);
      if (user?.list_appointments_by_scheduled_range !== payload.list_appointments_by_scheduled_range) refetchAppointments();

      typedQueryClient.setQueryData(userKey, payload);
    }
  });
